import { Stack } from '@mui/material';
import { Field, FieldProps } from 'formik';

import { useLocation } from '@redwoodjs/router';

import NPICurrencyInput from 'src/components/inputs/NPICurrencyInput/NPICurrencyInput';
import { NPICurrencyInputProps } from 'src/components/inputs/NPICurrencyInput/NPICurrencyInput.types';

interface NPICurrencyInputFieldProps extends NPICurrencyInputProps {
    isDisabled?: boolean;
    fieldName: string;
    errorMessage?: string;
    dimensions?: {
        width?: string;
        height?: string;
        borderRadius?: string;
    };
}

export function NPICurrencyInputField({
    fieldName,
    errorMessage,
    isDisabled,
    dimensions,
    ...props
}: NPICurrencyInputFieldProps) {
    const location = useLocation();

    return (
        <Stack
            sx={{
                width: dimensions?.width ?? '100%',
                height: dimensions?.height,
                borderRadius: dimensions?.borderRadius,
            }}
        >
            <Field name={fieldName}>
                {({ field, form }: FieldProps) => {
                    const { setFieldValue, touched, errors } = form;
                    const hasFormError = touched[fieldName] && Boolean(errors[fieldName]);
                    const hasError = hasFormError || props.error;

                    if (location.pathname.includes('merchant/add')) {
                        // FIXME: (HD) ServiceRequirements Transaction Charges stored as currency instead of cents edge case
                        const isValueCurrency = field.value - Math.floor(field.value) > 0;
                        return (
                            <>
                                <NPICurrencyInput
                                    name={field.name}
                                    error={hasError}
                                    defaultValueInCurrency={
                                        isValueCurrency ? field.value : undefined
                                    }
                                    defaultValueInCents={
                                        !isValueCurrency ? field.value ?? 0 : undefined
                                    }
                                    disabled={isDisabled}
                                    handleValue={(valueInCents) => {
                                        const parsedValue = Number.isFinite(valueInCents)
                                            ? valueInCents
                                            : 0;

                                        if (field.value !== parsedValue) {
                                            setFieldValue(field.name, parsedValue);
                                        }
                                    }}
                                    sx={{
                                        height: dimensions?.height,
                                        borderRadius: dimensions?.borderRadius,
                                    }}
                                    {...props}
                                />
                                {hasError && errorMessage && (
                                    <label className="error">{errorMessage}</label>
                                )}
                            </>
                        );
                    }

                    return (
                        <>
                            <NPICurrencyInput
                                name={field.name}
                                error={hasError}
                                defaultValueInCents={field.value ?? 0}
                                disabled={isDisabled}
                                handleValue={(valueInCents) => {
                                    const parsedValue = Number.isFinite(valueInCents)
                                        ? valueInCents
                                        : 0;

                                    if (field.value !== parsedValue) {
                                        setFieldValue(field.name, parsedValue);
                                    }
                                }}
                                sx={{
                                    height: dimensions?.height,
                                    borderRadius: dimensions?.borderRadius,
                                }}
                                {...props}
                            />
                            {hasError && errorMessage && (
                                <label className="error">{errorMessage}</label>
                            )}
                        </>
                    );
                }}
            </Field>
        </Stack>
    );
}

export default NPICurrencyInputField;
